import { AolDataItem, AolGroup } from '../types/ViewModel/AolItem';
import { formatAolFromToTimeUrl, formatAolUrlDate, getAolGroupDate } from './aol/aolDateUtils';
import { QueryParamValueProps, useQueryParamsHandler } from 'odfjell-query-manager';

export default () => {
    const { triggerQueryParamsUpdate } = useQueryParamsHandler();

    const onSelectAolGroup = (aolGroup: AolGroup) => {
        const queryParamValues: QueryParamValueProps[] = [];
        queryParamValues.push({ name: 'aolDate', newValue: formatAolUrlDate(getAolGroupDate(aolGroup)) });

        if (aolGroup.aolDataItems[0].aolVersion > 2) {
            queryParamValues.push({ name: 'fromTime', newValue: formatAolFromToTimeUrl(aolGroup.aolDataItems[0].reportFromTimeLocalTime) });
            queryParamValues.push({
                name: 'toTime', newValue: formatAolFromToTimeUrl(aolGroup.aolDataItems[0].reportToTimeLocalTime)
            });

        } else if (aolGroup.aolDataItems[0].noonReport) {
            queryParamValues.push({
                name: 'indexInDay', newValue: aolGroup.aolDataItems[0].noonReport.metadata.indexInDay.toString()
            });
        }

        triggerQueryParamsUpdate(queryParamValues);
    };

    const onSelectAolDataItem = (aolDataItem: AolDataItem) => {
        const queryParamValues: QueryParamValueProps[] = [];

        if (aolDataItem.aolVersion > 2) {
            queryParamValues.push({ name: 'fromTime', newValue: formatAolFromToTimeUrl(aolDataItem.reportFromTimeLocalTime) });
            queryParamValues.push({
                name: 'toTime', newValue: formatAolFromToTimeUrl(aolDataItem.reportToTimeLocalTime)
            });

        } else if (aolDataItem.noonReport) {
            queryParamValues.push({
                name: 'indexInDay', newValue: aolDataItem.noonReport.metadata.indexInDay.toString()
            });
        }

        triggerQueryParamsUpdate(queryParamValues);
    };

    return {
        onSelectAolGroup,
        onSelectAolDataItem,
    };
};
